import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonSlides, ModalController } from '@ionic/angular';
import { HelpersService } from 'src/app/_services/helpers.service';

@Component({
  selector: 'app-modal-image',
  templateUrl: './modal-image.component.html',
  styleUrls: ['./modal-image.component.scss'],
})
export class ModalImageComponent implements OnInit {
  @ViewChild(IonSlides) slides: IonSlides;
  @Input('img') img: any;
  @Input('type') type: any;

  slideOptsOne = {
    zoom: true,
    centeredSlides: true,
    pagination: true
  };

  slideOptsMulti = {
    initialSlide: 0,
    loop: true,
    autoplay: {
      delay: 3000,
    },
    speed: 400,
    zoom: true,
    centeredSlides: true,
  };

  constructor(private modalController: ModalController, public helper: HelpersService) {}

  ngOnInit() {}

  ionViewDidEnter() {
    this.slides.update();
  }

  async zoom(zoomIn: boolean) {
    const slider = await this.slides.getSwiper();
    const zoom = slider.zoom;
    zoomIn ? zoom.in() : zoom.out();
  }

  close() {
    this.modalController.dismiss();
  }
}
